module.exports = __webpack_public_path__ + "static/media/icon.efbc634b.png";